import ReactDOM from 'react-dom/client'
import VConsole from 'vconsole'
import App from './App'
import { commonUtils } from './helpers/commonUtils'
import { doPatch } from './patch/removeChildPatch'

doPatch()

if (
  (process.env.REACT_APP_ENV === 'local' || process.env.REACT_APP_ENV === 'dev') &&
  commonUtils.getIsMobile()
) {
  new VConsole()
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
)
